import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PointType, pointTypeMap } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { CategoryPoint } from 'src/app/pages/custom-route/interfaces/custom-route.response';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public indexCard: InputSignal<number> = input.required<number>();
  public title: InputSignal<string> = input.required<string>()
  public img: InputSignal<string> = input.required<string>();
  public defaultImg: InputSignal<string> = input.required<string>();
  public durationMinutes: InputSignal<number> = input.required<number>();
  public isDuration15Minutes: InputSignal<boolean> = input.required<boolean>();
  
  public handleImgError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target) {
      const defaultImg = this.defaultImg();
      if (!defaultImg) return;
      
      target.src = this.defaultImg();
    }
  }
}
